import { Box, Container, Paper, Typography } from '@mui/material';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { BotaoVoltarPdv } from '../../components/botao-voltar-pdv';

export function LojaNaoEncontradaPage(): JSX.Element {
  return (
    <Container maxWidth="sm" sx={{ pt: 8 }}>
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 2 }}>
          <StorefrontOutlinedIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
        </Box>
        <Typography variant="h5" gutterBottom>
          Endereço inválido
        </Typography>
        <Typography color="text.secondary">
          Não encontramos nenhuma loja para este endereço. Verifique o link e tente novamente.
        </Typography>

        <BotaoVoltarPdv />
      </Paper>
    </Container>
  );
}
